import { AWARD_TYPE } from '@/constants/awards'

export default award => {
  const awardType = award.type
  const isCheckinAward = awardType === AWARD_TYPE.CHECKIN
  const isInitiativeStatusChangeAward = awardType === AWARD_TYPE.INITIATIVE_STATUS
  const isGoalCommentAward = awardType === AWARD_TYPE.GOAL_COMMENT
  const isInitiativeCommentAward = awardType === AWARD_TYPE.INITIATIVE_COMMENT
  const isInitiativeAward = awardType === AWARD_TYPE.INITIATIVE
  const isKrAward = award.type === AWARD_TYPE.KEY_RESULT
  const isGoalAward = award.type === AWARD_TYPE.GOAL
  return {
    awardType,
    isInitiativeStatusChangeAward,
    isCheckinAward,
    isCommentAward: isGoalCommentAward || isInitiativeCommentAward,
    onKr: isCheckinAward || isKrAward,
    onInitiative: isInitiativeStatusChangeAward || isInitiativeAward || isInitiativeCommentAward,
    isKrAward,
    isGoalAward,
    isInitiativeAward
  }
}
